import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '1rem 0',
    margin: 0,
  },
  link: {
    textDecoration: 'none',
    fontWeight: '500',
    color: theme.palette.primary.dark,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const ProviderLinkSubtitle = ({name, href}) => {
  const classes = useStyles();
  return (
    <Typography
      variant="h3"
      color="primary"
      className={classes.root}
    >
      Provided by <Link className={classes.link} to={href}>{name}</Link>.
    </Typography>
  );
};

ProviderLinkSubtitle.propTypes = {
  name: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

export default ProviderLinkSubtitle;
